import React from "react";
import { Button, ButtonProps } from "@mui/material";

const GREEN = "#68AC39";
const GREEN_HOVER = "#5a9430";

/**
 * Standard green "accept" button used across the app for confirming a positive
 * action (e.g. Initiatives' "Save Changes"). For destructive/negative actions
 * use DangerButton instead; for the default blue action use BasicButton.
 */
export const ConfirmButton: React.FC<ButtonProps> = ({ sx, children, ...props }) => (
    <Button
        variant="contained"
        size="small"
        sx={{
            borderRadius: 2,
            height: "36px",
            backgroundColor: GREEN,
            "&:hover": { backgroundColor: GREEN_HOVER },
            "&.Mui-disabled": { backgroundColor: GREEN, opacity: 0.45 },
            ...sx,
        }}
        {...props}
    >
        {children}
    </Button>
);
